import { Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MiniTable from '../../../components/mini-table';
import useFormatter from '../../../hooks/useFormatter';
import { compareNumbers } from '../../../util/number';
import { compareStrings } from '../../../util/string';
import TableCellEllipsis from "../../../components/table-cell-ellipsis";
import { formatNumber } from "chart.js/helpers";

export default function EmpresaLicencasTable({ dataSource, loading, miniTableRef, onClick, onSelectedIdsChange, selectedIds, title }) {
  const { t } = useTranslation();
  const { formatDate } = useFormatter();

  const fireClick = empresa => typeof onClick === 'function' ? onClick(empresa) : undefined;

  const columns = [
    {
      title: t('Natureza'),
      dataIndex: 'natureza',
      key: 'natureza',
      sorter: (a, b) => compareStrings(a.nome, b.nome),
      render: (text, record) => (
        <Button type="link" onClick={() => fireClick(record)}>
          {text ?? t('(não preenchido)')}
        </Button>
      ),
    },
    {
      title: t('Número de Ordem'),
      dataIndex: 'numeroOrdem',
      key: 'numeroOrdem',
      sorter: (a, b) => compareNumbers(a.numeroOrdem, b.numeroOrdem),
      render: (text, record) => formatNumber(record.numeroOrdem),
    },
    {
      title: t('Período Inicial'),
      dataIndex: 'periodoInicial',
      key: 'periodoInicial',
      width: 120,
      sorter: (a, b) => compareStrings(a.periodoInicial, b.periodoInicial),
      render: (text, record) => formatDate(record.periodoInicial),
    },
    {
      title: t('Período Final'),
      periodoIndex: 'periodoFinal',
      key: 'periodoFinal',
      width: 120,
      sorter: (a, b) => compareStrings(a.periodoFinal, b.periodoFinal),
      render: (text, record) => formatDate(record.periodoFinal),
    },
    {
      title: t('Observação'),
      dataIndex: 'obs',
      key: 'obs',
      sorter: (a, b) => compareStrings(a.obs, b.obs),
      render: (text) => <TableCellEllipsis text={text}/>
    },
  ];

  return (
    <MiniTable
      ref={miniTableRef}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      title={title}
      rowSelection={{
        selectedRowKeys: selectedIds,
        onChange: onSelectedIdsChange,
      }}
      scroll={{
        y: 'auto'
      }}
    />
  );
}

EmpresaLicencasTable.propTypes = {
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  miniTableRef: PropTypes.object,
  onClick: PropTypes.func,
  onSelectedIdsChange: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.func,
};
